var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nova-senha-link-expirado"},[_c('h2',[_vm._v("JÁ EXISTE UMA SESSÃO ATIVA")]),_c('div',[_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"link",attrs:{"to":{name: 'dashboard'}}},[_vm._v("Ir para página inicial")])],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('img',{staticClass:"link-expirado__image",attrs:{"src":"https://i.imgur.com/hu80UGU.png"}})])
}]

export { render, staticRenderFns }